import { Component } from "react";
import { connect } from "react-redux";
import { ThunkDispatchProp } from "../../actions/thunkAction";
import { ProductManagerContext, LiveEventsChangeEvent } from "./ProductManagerContext";
import { fetchEventsByIds } from "../../actions/liveEvents";

export class LiveEventChangeHandler extends Component<ThunkDispatchProp> {
  static contextType = ProductManagerContext;
  context!: React.ContextType<typeof ProductManagerContext>;

  listenerHandler?: number;
  fetchInterval?: number;
  staleLiveEventIds: number[] = [];

  handleChangedLiveEvents = (event: LiveEventsChangeEvent) => {
    this.staleLiveEventIds.push(...event.eventIds);
  }

  componentDidMount() {
    this.listenerHandler = this.context.subscribeToLiveEventsChanges(this.handleChangedLiveEvents);
    this.fetchInterval = window.setInterval(() => {
      if (this.staleLiveEventIds.length > 0) {
        const stales = this.staleLiveEventIds;
        this.staleLiveEventIds = [];
        this.props.dispatch(fetchEventsByIds(stales));
      }
    }, 1000);
  }

  componentWillUnmount() {
    this.listenerHandler && this.context.unsubscribeFromLiveEventsChanges(this.listenerHandler);
    window.clearInterval(this.fetchInterval);
  }

  render = () => null;
}

export default connect()(LiveEventChangeHandler);
